<ion-item>
  <ion-icon slot="start" size="large" src="assets/icons/unit-resources/resource-fire-truck.svg"></ion-icon>
  <ion-label>{{ 'Mobile.UnitCount' | translate }}: {{ unitCount }}</ion-label>
</ion-item>
